import Vue from 'vue'
import RootToastsMixin from 'GroomyRoot/mixins/Toasts.js'

export default Vue.util.mergeOptions(RootToastsMixin, {
    methods: {
        
    }
})
